import UserPrepaidCardApi from '@apis/prepaid/UserPrepaidCardApi';
import queries from '@apis/queries';
import useToast from '@hooks/ui/useToast';
import { ErrorResponse } from '@models/error';
import { useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useState } from 'react';

interface Props {
    id?: string;
    initialValue: boolean;
}

function useToggleFavoritePrepaidCard({ id, initialValue }:Props) {
    const [isFavorites, setIsFavorites] = useState<boolean>(initialValue);
    const toast = useToast();
    const queryClient = useQueryClient();
    const handleToggleFavorite = () => {
        if (!id) {
            return;
        }
        const newValue = !isFavorites;
        setIsFavorites(newValue);
        UserPrepaidCardApi.toggleFavorite(id)
            .then(async () => {
                await queryClient.invalidateQueries({ queryKey: queries.userPrepaidCard._def });
                toast.info(newValue ? '즐겨찾기에 추가되었습니다.' : '즐겨찾기에서 제거되었습니다.');
            })
            .catch((e: AxiosError<ErrorResponse>) => {
                setIsFavorites(!newValue);
                toast.error(e.response?.data.message || '오류가 발생하였습니다.');
            });
    };
    return {
        isFavorites, handleToggleFavorite,
    };
}

export default useToggleFavoritePrepaidCard;
